import InnovationContentStats from './InnovationContentStats';

function InnovationSpaceGraphs() {
  return (
    <div className="grid grid-cols-1 gap-6">
      <InnovationContentStats />
    </div>
  );
}

export default InnovationSpaceGraphs;
